// extracted by mini-css-extract-plugin
export var addButton = "_o2-0";
export var border = "_o2-8";
export var check = "_o2-h";
export var danger = "_o2-6";
export var dropdownContainer = "_o2-1";
export var editModalBody = "_o2-j";
export var footerContainer = "_o2-i";
export var fullWidth = "_o2-a";
export var hide = "_o2-9";
export var icon = "_o2-3";
export var input = "_o2-7";
export var inputFlex = "_o2-b";
export var inputWrapper = "_o2-c";
export var manualFocus = "_o2-5";
export var optionButton = "_o2-4";
export var pillWrapper = "_o2-e";
export var pointer = "_o2-2";
export var showOverflow = "_o2-f";
export var tagsFlex = "_o2-d";
export var xButton = "_o2-g";